<template>
    <div class="app-container">
      <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :selection="selection" :col-span="colSpan" :get-action="queryApi" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @afterFetchOriginalData="afterFetchOriginalData" @header-contextmenu="SortableTable.handleHeaderContextmenu">
        <template v-slot:baseForm>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessLogisticsProductLang.productCode')" prop="productCode">
              <BjInput v-model="queryParams.productCode" :placeholder="$t('BusinessLogisticsProductLang.productCode')" @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessLogisticsProductLang.productName')" prop="productName">
              <BjInput v-model="queryParams.productName" :placeholder="$t('BusinessLogisticsProductLang.productName')" @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessLogisticsProductLang.productType')" prop="productType">
              <BjSelectLov v-model="queryParams.productType" :option-list="PRODUCT_ALL_TYPE_LIST" :placeholder="$t('BusinessLogisticsProductLang.productType')" @change="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessLogisticsProductLang.status')" prop="status">
              <BjSelectLov v-model="queryParams.status" :option-list="PRODUCT_STATUS_LIST" :placeholder="$t('BusinessLogisticsProductLang.status')" @change="handleQuery" />
            </el-form-item>
          </el-col>
        </template>

        <template v-slot:tableOperation="tableOperationProp">
          <el-col>
            <el-button type="primary" class="main-btn" @click="onAdd">{{ $t('addText') }}</el-button>
            <el-button :disabled="tableOperationProp.notSelected" type="primary" class="main-btn" @click="onDelete">{{ $t('bulkDelText') }}</el-button>
          </el-col>
        </template>

        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
              <template slot-scope="scope">
                <template v-if="false" />
                <template v-else-if="col.prop === 'scanNode'">
                  {{ SCAN_NODE_LIST.bjGet(scope.row.scanNode) }}
                </template>
                <template v-else-if="col.prop === 'productType'">
                  {{ PRODUCT_ALL_TYPE_LIST.bjGet(scope.row.productType) }}
                </template>
                <template v-else-if="col.prop === 'orderType'">
                  {{ ORDER_TYPE_LIST.bjGet(scope.row.orderType) }}
                </template>
                <template v-else-if="col.prop === 'status'">
                  {{ PRODUCT_STATUS_LIST.bjGet(scope.row.status) }}
                </template>
                <template v-else-if="col.prop === 'specialGoodsTypes'">
                  {{ formatSpecialGoodsTypes(scope.row.specialGoodsTypes) }}
                </template>
                <template v-else-if="col.prop === 'weightUnit'">
                  {{ WEIGHT_UNIT_LIST.bjGet(scope.row.weightUnit) }}
                </template>
                <template v-else-if="col.prop === 'lengthUnit'">
                  {{ LENGTH_UNIT_LIST.bjGet(scope.row.lengthUnit) }}
                </template>
                <!-- 使用 minDeliveryDays/maxDeliveryDays 拼接。 -->
                <template v-else-if="col.prop === 'deliveryDays'">
                  {{ formatDeliveryDays(scope.row) }}
                </template>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template slot-scope="props">
                <el-button type="text" class="edit-btn" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
                <el-button type="text" class="edit-btn" @click="onSetting(props.row)">{{ $t('BusinessLogisticsProductLang.productEdit') }}</el-button>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>

      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="1000px"
        append-to-body
        :close-on-click-modal="false"
        :before-close="handleDialogClose"
        custom-class="logistics-product-dialog"
      >
        <el-form ref="productForm" :model="form" :rules="rules" label-position="top" class="product-form">
          <BjDivider>{{ $t('BusinessLogisticsProductLang.basicInfo') }}</BjDivider>
          <el-row :gutter="40" class="product-section-content">
            <el-col :span="12">
              <el-form-item :label="$t('BusinessLogisticsProductLang.productCode')" prop="productCode">
                <BjInput v-model="form.productCode" :placeholder="$t('BusinessLogisticsProductLang.productCodePlaceholder')" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('BusinessLogisticsProductLang.productName')" prop="productName">
                <BjInput v-model="form.productName" :placeholder="$t('BusinessLogisticsProductLang.productNamePlaceholder')" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item class="boolean-form-item" :label="$t('BusinessLogisticsProductLang.allowModifyOrder')" prop="allowModifyOrder">
                <el-radio-group v-model="form.allowModifyOrder">
                  <el-radio :label="true">{{ $t('yesText') }}</el-radio>
                  <el-radio :label="false">{{ $t('noText') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item class="boolean-form-item" :label="$t('BusinessLogisticsProductLang.arrearsStopService')" prop="arrearsStopService">
                <el-radio-group v-model="form.arrearsStopService">
                  <el-radio :label="true">{{ $t('yesText') }}</el-radio>
                  <el-radio :label="false">{{ $t('noText') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <BjDivider>{{ $t('BusinessLogisticsProductLang.goodsConfig') }}</BjDivider>
          <el-row :gutter="40" class="product-section-content">
            <el-col :span="24">
              <el-form-item :label="$t('BusinessLogisticsProductLang.specialGoodsType')" prop="specialGoodsTypes">
                <el-checkbox-group v-model="form.specialGoodsTypes" class="special-goods-group">
                  <el-checkbox v-for="item in SPECIAL_GOODS_TYPE_LIST" :key="item.value" :label="item.value">
                    {{ item.label }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('BusinessLogisticsProductLang.weightUnit')" prop="weightUnit">
                <BjSelectLov v-model="form.weightUnit" :option-list="WEIGHT_UNIT_LIST" :placeholder="$t('chooseText')" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('BusinessLogisticsProductLang.lengthUnit')" prop="lengthUnit">
                <BjSelectLov v-model="form.lengthUnit" :option-list="LENGTH_UNIT_LIST" :placeholder="$t('chooseText')" />
              </el-form-item>
            </el-col>
          </el-row>

          <BjDivider>{{ $t('BusinessLogisticsProductLang.businessConfig') }}</BjDivider>
          <el-row :gutter="20" class="product-section-content business-config-row">
            <el-col :span="8">
              <el-form-item class="business-form-item" prop="scanNode">
                <template slot="label">
                  <span>{{ $t('BusinessLogisticsProductLang.scanNode') }}</span>
                  <el-tooltip :content="$t('BusinessLogisticsProductLang.scanNodeTips')" placement="top">
                    <i class="el-icon-question form-tip-icon" />
                  </el-tooltip>
                </template>
                <BjSelectLov v-model="form.scanNode" :option-list="SCAN_NODE_LIST" :placeholder="$t('chooseText')" :disabled="isEdit" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item class="business-form-item" prop="orderType">
                <template slot="label">
                  <span>{{ $t('BusinessLogisticsProductLang.orderType') }}</span>
                  <el-tooltip :content="$t('BusinessLogisticsProductLang.orderTypeTips')" placement="top">
                    <i class="el-icon-question form-tip-icon" />
                  </el-tooltip>
                </template>
                <BjSelectLov v-model="form.orderType" :option-list="ORDER_TYPE_LIST" :placeholder="$t('chooseText')" :disabled="isEdit" @change="handleOrderTypeChange" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item class="business-form-item" prop="productType">
                <template slot="label">
                  <span>{{ $t('BusinessLogisticsProductLang.productType') }}</span>
                  <el-tooltip :content="$t('BusinessLogisticsProductLang.orderTypeTips')" placement="top">
                    <i class="el-icon-question form-tip-icon" />
                  </el-tooltip>
                </template>
                <BjSelectLov v-model="form.productType" :option-list="PRODUCT_TYPE_LIST" :placeholder="$t('chooseText')" :disabled="isEdit" :loading="productTypeLoading" />
              </el-form-item>
            </el-col>
          </el-row>

          <BjDivider>{{ $t('BusinessLogisticsProductLang.otherConfig') }}</BjDivider>
          <el-row :gutter="40" class="product-section-content">
            <el-col :span="12">
              <el-form-item :label="$t('BusinessLogisticsProductLang.minDeliveryDays')" prop="minDeliveryDays">
                <BjInputNumber v-model="form.minDeliveryDays" :min="1" :precision="0" :placeholder="$t('BusinessLogisticsProductLang.minDeliveryDaysPlaceholder')" not-auto-zero>
                  <template #append>{{ $t('BusinessLogisticsProductLang.dayUnit') }}</template>
                </BjInputNumber>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('BusinessLogisticsProductLang.maxDeliveryDays')" prop="maxDeliveryDays">
                <BjInputNumber v-model="form.maxDeliveryDays" :min="1" :precision="0" :placeholder="$t('BusinessLogisticsProductLang.maxDeliveryDaysPlaceholder')" not-auto-zero>
                  <template #append>{{ $t('BusinessLogisticsProductLang.dayUnit') }}</template>
                </BjInputNumber>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('BusinessLogisticsProductLang.sortNum')" prop="sortNum">
                <BjInputNumber v-model="form.sortNum" :min="0" :precision="0" :placeholder="$t('inputText')" not-auto-zero />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('BusinessLogisticsProductLang.businessChannel')" prop="businessId">
                <BjSelectLov
                  v-model="form.businessId"
                  :option-list="logisticsChannelAllList"
                  :placeholder="$t('BusinessLogisticsProductLang.businessChannelPlaceholder')"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleDialogClose">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="handleSubmit">{{ $t('okText') }}</el-button>
        </div>
      </el-dialog>
    </div>
  </template>

  <script>
    import pageMiXin from '@/utils/page-mixin.js';
    import { logisticApi } from '@/api';
    import { getLanguage } from '@/lang/index';

    const getDefaultForm = () => ({
      id: null,
      status:'1',
      productCode: null,
      productName: null,
      allowModifyOrder: true,
      arrearsStopService: false,
      specialGoodsTypes: ['1'],
      weightUnit: '1',
      lengthUnit: '1',
      scanNode: '2',
      orderType: '2',
      productType: null,
      minDeliveryDays: null,
      maxDeliveryDays: null,
      sortNum: null,
      businessId: null,
    });

    export default {
      name: 'BusinessLogisticsProduct',
      mixins: [pageMiXin],
      data() {
        return {
          language: getLanguage(),
          colSpan: 4,
          queryApi: logisticApi.getLogisticProductList,
          queryParams: {
            productCode: null,
            productName: null,
            productType: null,
            status: null,
          },
          PRODUCT_ALL_TYPE_LIST:[],
          PRODUCT_STATUS_LIST: [
            { label: this.$t('enableText'), value: '1' },
            { label: this.$t('disableText'), value: '2' },
          ],
          SCAN_NODE_LIST: [
            { label: this.$t('BusinessLogisticsProductLang.arrivalScanNode'), value: '1' },
            { label: this.$t('BusinessLogisticsProductLang.inboundScanNode'), value: '2' },
          ],
          SPECIAL_GOODS_TYPE_LIST: [
            { label: this.$t('BusinessLogisticsProductLang.generalGoods'), value: '1' },
            { label: this.$t('BusinessLogisticsProductLang.innerBattery'), value: '2' },
            { label: this.$t('BusinessLogisticsProductLang.pureBattery'), value: '3' },
            { label: this.$t('BusinessLogisticsProductLang.magnetic'), value: '4' },
            { label: this.$t('BusinessLogisticsProductLang.liquid'), value: '5' },
            { label: this.$t('BusinessLogisticsProductLang.powder'), value: '6' },
          ],
          WEIGHT_UNIT_LIST: [
            { label: this.$t('BusinessLogisticsProductLang.kilogram'), value: '1' },
          ],
          LENGTH_UNIT_LIST: [
            { label: this.$t('BusinessLogisticsProductLang.centimeter'), value: '1' },
          ],
          ORDER_TYPE_LIST: [
            { label: this.$t('BusinessLogisticsProductLang.smallPackage'), value: '1' },
            { label: this.$t('BusinessLogisticsProductLang.express'), value: '2' },
            { label: this.$t('BusinessLogisticsProductLang.fba'), value: '3' },
          ],
          PRODUCT_TYPE_LIST: [],
          productTypeLoading: false,
          productTypeRequestSeq: 0,
          dialogVisible: false,
          isEdit: false,
          form: getDefaultForm(),
          labelList: [
            { label: this.$t('BusinessLogisticsProductLang.productCode'), prop: 'productCode', isCheck: true, disabled: false, width: 140 },
            { label: this.$t('BusinessLogisticsProductLang.productName'), prop: 'productName', isCheck: true, disabled: false, width: 140 },
            { label: this.$t('BusinessLogisticsProductLang.scanNode'), prop: 'scanNode', isCheck: true, disabled: false, width: 190 },
            { label: this.$t('BusinessLogisticsProductLang.productType'), prop: 'productType', isCheck: true, disabled: false, width: 140 },
            { label: this.$t('BusinessLogisticsProductLang.orderType'), prop: 'orderType', isCheck: true, disabled: false, width: 130 },
            { label: this.$t('BusinessLogisticsProductLang.status'), prop: 'status', isCheck: true, disabled: false, width: 100 },
            // 暂用 departurePortCity ———>> 先置空
            { label: this.$t('BusinessLogisticsProductLang.departurePortCity'), prop: 'departurePortCity', isCheck: false, disabled: false, width: 150 },
            { label: this.$t('BusinessLogisticsProductLang.specialGoodsType'), prop: 'specialGoodsTypes', isCheck: true, disabled: false, width: 150 },
            { label: this.$t('BusinessLogisticsProductLang.weightUnit'), prop: 'weightUnit', isCheck: true, disabled: false, width: 130 },
            { label: this.$t('BusinessLogisticsProductLang.lengthUnit'), prop: 'lengthUnit', isCheck: true, disabled: false, width: 130 },
            { label: this.$t('BusinessLogisticsProductLang.sortNum'), prop: 'sortNum', isCheck: true, disabled: false, width: 120 },
            { label: this.$t('BusinessLogisticsProductLang.deliveryDays'), prop: 'deliveryDays', isCheck: true, disabled: false, width: 170 },
            // 暂用 waybillSource ———>> 先置空
            { label: this.$t('BusinessLogisticsProductLang.waybillSource'), prop: 'waybillSource', isCheck: false, disabled: false, width: 150 },
            // 暂用 sheetType ———>> 先置空
            { label: this.$t('BusinessLogisticsProductLang.sheetType'), prop: 'sheetType', isCheck: false, disabled: false, width: 150 },
            { label: this.$t('BusinessLogisticsProductLang.operation'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 165 },
          ],
        };
      },
      computed: {
        dialogTitle() {
          return this.isEdit ? this.$t('BusinessLogisticsProductLang.editProduct') : this.$t('BusinessLogisticsProductLang.addProduct');
        },
        rules() {
          return {
            productName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            allowModifyOrder: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
            weightUnit: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
            lengthUnit: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
            scanNode: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
            orderType: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
            productType: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
            minDeliveryDays: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            maxDeliveryDays: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            sortNum: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          };
        },
      },
      mounted() {
        // 弹出框内：服务渠道（别处是物流渠道）
        logisticApi.getLogisticsBusiness({}).then(res => {
          if (!res.failed) {
            this.logisticsChannelAllList = (res.content || []).map(item => ({
              label: item.name,
              value: item.id
            }));
          }
        });
        // 条件查询 产品类型
        logisticApi.getLogisticProductTypeList({groupCode: 'LOG_PRODUCT_TYPE'}).then(res => {
          if (!res.failed) {
            this.PRODUCT_ALL_TYPE_LIST = (res || []).map(item => ({
              label: this.language === 'zh' ? item.valueName : item.valueNameEn,
              value: item.valueCode
            }));
          }
        });
      },
      methods: {
        formatDeliveryDays(row) {
          const { minDeliveryDays, maxDeliveryDays } = row;
          const formatValue = value => (value === null || value === undefined || value === '' ? '-' : value);
          return `${formatValue(minDeliveryDays)}-${formatValue(maxDeliveryDays)}`;
        },
        formatSpecialGoodsTypes(value) {
          return (Array.isArray(value) ? value : [])
            .map(item => this.SPECIAL_GOODS_TYPE_LIST.bjGet(String(item)))
            .filter(Boolean)
            .join(',');
        },
        getEditFormData(row) {
          const rowData = JSON.parse(JSON.stringify(row));
          const form = Object.assign(getDefaultForm(), rowData);
          ['weightUnit', 'lengthUnit', 'scanNode', 'orderType', 'productType'].forEach(key => {
            if (form[key] !== null && form[key] !== undefined && form[key] !== '') {
              form[key] = String(form[key]);
            }
          });
          form.specialGoodsTypes = Array.isArray(form.specialGoodsTypes)
            ? form.specialGoodsTypes.map(item => String(item))
            : [];
          return form;
        },
        getProductTypeList(orderType = this.form.orderType) {
          if (!orderType) {
            this.PRODUCT_TYPE_LIST = [];
            return Promise.resolve([]);
          }
          const requestSeq = ++this.productTypeRequestSeq;
          this.productTypeLoading = true;
          return logisticApi.getLogisticProductTypeList({ groupCode: 'LOG_PRODUCT_TYPE', valueType: orderType }).then(res => {
            if (requestSeq !== this.productTypeRequestSeq) return [];
            const list = Array.isArray(res) ? res : (res && res.content) || [];
            this.PRODUCT_TYPE_LIST = list.map(item => ({
              label: this.language === 'zh' ? item.valueName : item.valueNameEn,
              value: item.valueCode
            }));
            if (this.form.productType && !this.PRODUCT_TYPE_LIST.some(item => item.value === this.form.productType)) {
              this.form.productType = null;
            }
            return this.PRODUCT_TYPE_LIST;
          }).finally(() => {
            if (requestSeq === this.productTypeRequestSeq) {
              this.productTypeLoading = false;
            }
          });
        },
        handleOrderTypeChange(orderType) {
          this.form.productType = null;
          this.getProductTypeList(orderType);
        },
        onAdd() {
          this.isEdit = false;
          this.form = getDefaultForm();
          this.dialogVisible = true;
          this.getProductTypeList(this.form.orderType);
        },
        onEdit(row) {
          this.isEdit = true;
          this.form = this.getEditFormData(row);
          this.dialogVisible = true;
          this.getProductTypeList(this.form.orderType);
        },
        onSetting(row) {
          this.$router.push({
            name: 'BusinessLogisticsProductSetting',
            query: { id: row.id }
          });
        },
        onDelete() {
          const ids = this.selectedRows.map(e => e.id);
          this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
          })
            .then(() => {
              logisticApi.delLogisticProductList({ids: ids}).then(res => {
                if (res.failed === false) {
                  this.$message.success(this.$t('toast.operationSuccessText'));
                  setTimeout(() => {
                    this.reFresh();
                  }, 500);
                }
              });
            });
        },
        buildApiData() {
          const apiData = this.$lodash.cloneDeep ? this.$lodash.cloneDeep(this.form) : this.$lodash.clone(this.form);
          apiData.minDeliveryDays = Number(apiData.minDeliveryDays);
          apiData.maxDeliveryDays = Number(apiData.maxDeliveryDays);
          apiData.sortNum = Number(apiData.sortNum);
          return apiData;
        },
        handleSubmit() {
          this.$refs.productForm.validate(valid => {
            if (!valid) return;
            if (Number(this.form.maxDeliveryDays) < Number(this.form.minDeliveryDays)) {
              this.$message.warning(this.$t('BusinessLogisticsProductLang.maxDeliveryDaysLessThanMin'));
              return;
            }
            const apiData = this.buildApiData();
            const action = this.isEdit ? logisticApi.editLogisticProductList : logisticApi.addLogisticProductList;
            action(apiData).then(res => {
              if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                this.handleDialogClose();
                this.reFresh();
              }
            });
          });
        },
        handleDialogClose() {
          this.dialogVisible = false;
          this.form = getDefaultForm();
          this.PRODUCT_TYPE_LIST = [];
          this.$nextTick(() => {
            if (this.$refs.productForm) {
              this.$refs.productForm.clearValidate();
            }
          });
        },

      },
    };
  </script>

  <style lang="scss" scoped>
  ::v-deep .bj-page .el-form-item__label {
    display: none;
  }

  ::v-deep .logistics-product-dialog {
    .el-dialog__header {
      padding: 16px 20px 6px;
    }

    .el-dialog__body {
      padding: 0 20px 8px;
    }

    .el-dialog__footer {
      padding: 6px 20px 14px;
    }

    .product-form {
      .bj-divider {
        padding: 8px 0;
        margin-bottom: 10px;
      }

      .el-form-item {
        margin-bottom: 14px;
      }

      .el-form-item__label {
        float: none;
        display: block;
        padding: 0 0 4px;
        line-height: 18px;
        white-space: normal;
        word-break: normal;
      }

      .el-form-item__content {
        margin-left: 0 !important;
        line-height: 24px;
      }

      .el-radio-group,
      .el-checkbox-group {
        min-height: 24px;
      }

      .product-section-content {
        box-sizing: border-box;
        padding-left: 48px;
      }

      .boolean-form-item {
        margin-bottom: 18px;

        .el-form-item__label {
          padding-bottom: 4px;
        }

        .el-radio-group {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .el-radio {
          margin-right: 0;
          line-height: 18px;
        }
      }

      .business-form-item {
        margin-bottom: 18px;

        .el-form-item__label {
          padding-bottom: 8px;
        }
      }

      .business-config-row {
        .el-select,
        .bj-select-lov {
          width: 100%;
        }
      }
    }

    .special-goods-group {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      column-gap: 0;
      row-gap: 4px;

      .el-checkbox {
        margin-right: 0;
        white-space: nowrap;
      }
    }

    .form-tip-icon {
      margin-left: 4px;
      color: #909399;
      font-size: 14px;
    }

    .dialog-footer {
      padding-top: 2px;
      text-align: center;

      .el-button {
        min-width: 120px;
      }
    }
  }
  </style>
